import { render, staticRenderFns } from "./PaymentPeriodsSelectbox.vue?vue&type=template&id=d08a5fe2"
import script from "./PaymentPeriodsSelectbox.vue?vue&type=script&lang=js"
export * from "./PaymentPeriodsSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports